module.exports = __webpack_public_path__ + "img/1562872009.602ccc5c.jpg";